import type { Components, Theme } from '@mui/material/styles'
import * as DT from './designTokens'

export const componentOverrides: Components<Theme> = {
  MuiButton: {
    defaultProps: { disableElevation: true },
    styleOverrides: {
      root: { textTransform: 'none', fontWeight: 600 },
    },
  },
  MuiCard: {
    defaultProps: { variant: 'outlined' },
  },
  MuiTextField: {
    defaultProps: { size: 'small', variant: 'outlined' },
  },
  MuiTooltip: {
    defaultProps: {
      arrow: true,
      enterDelay: 300,
      enterNextDelay: 200,
    },
    styleOverrides: {
      tooltip: {
        backgroundColor: DT.paletteSecondaryInk,
        color: '#FFFFFF',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: 1.4,
        letterSpacing: '0.01em',
        padding: '6px 10px',
        borderRadius: 8,
        maxWidth: 280,
        boxShadow: '0 4px 12px rgba(15, 23, 42, 0.18)',
      },
      arrow: {
        color: DT.paletteSecondaryInk,
      },
    },
  },
}
